import React from 'react';
import AICompanionInterface from './AICompanionInterface';
import './AICompanionInterface.css';

function App() {
  return (
    <div className="App">
      <AICompanionInterface />
    </div>
  );
}

export default App;
